import { Star, StarFilled } from '@audio-network/componentlibrary/icons'

import { FavouriteButtonProps } from './FavouriteButton.types'
import clsx from 'clsx'
import { redirectToHref } from '@/utils/window'
import { sendAnalytics } from '@audio-network/analytics'
import styles from './FavouriteButton.module.css'
import useFavouritesStore from '@/stores/favouritesStore'
import { useSession } from '@/context/Session'
import { useState } from 'react'
import { useTranslation } from 'next-i18next'

const FavouriteButton = ({
	className,
	source,
	track,
}: FavouriteButtonProps): JSX.Element => {
	const { user } = useSession()
	const favouriteTracks = useFavouritesStore((state) => state.favouriteTracks)
	const toggleFavourite = useFavouritesStore((state) => state.toggleFavourite)

	const isFavourite = !!favouriteTracks?.some(
		(favouriteTrack) => favouriteTrack === track.id
	)

	const [pressed, setPressed] = useState(undefined)

	const { t } = useTranslation(['trackrow'])

	const handleClick = (): void => {
		setPressed(typeof pressed === 'undefined' ? !isFavourite : !pressed)

		if (!user?.id) {
			redirectToHref(`/favourites/login?track=${track.id}`)
			return
		}

		sendAnalytics({
			noun: isFavourite ? 'Remove from Favourites' : 'Add to Favourites',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				TrackTitle: track.title,
				TrackId: track.id,
				AlbumNo: track.album.number,
				TrackSource: source,
				Genre: track.album.genre,
				Catalogue: track.album.catalogue.name,
			},
		})

		toggleFavourite(track.id)
	}

	return (
		<button
			aria-label={t('track-actions.favourite-track')}
			aria-pressed={pressed ?? isFavourite}
			onClick={handleClick}
			className={clsx(styles.button, className)}
		>
			<Star className={styles.empty} color="ui1" />
			<StarFilled
				className={clsx(styles.filled, pressed && styles.bounce)}
				color="yellow"
			/>
		</button>
	)
}

export default FavouriteButton
